const styles = {
    Container: {
        px: 4,
        py: 4,
        maxWidth: 900,
        margin: '0 auto'
    },
    root: {
        fontSize: 2,
        fontWeight: 300,
        color: 'text',
        bg: 'background',
    },
    a: {
        color: 'blueDark',
        textDecoration: 'underline',
        position: 'relative',
        '&:hover': {
            color: 'secondary',
        }
    },
    h1: {
        fontSize: 5,
        fontWeight: 600,
        margin: null,
        marginTop: 1,
        marginLeft: 0,
        marginBottom: 3,
        marginRight: 0
    },
    h2: {
        fontSize: 4,
        fontWeight: 500,
        margin: null,
        marginTop: 7,
        marginLeft: 0,
        marginBottom: 3,
        marginRight: 0,
        paddingBottom: 3,
        borderBottom: t => `1px solid ${t.colors.border}`,
    },
    h3: {
        fontSize: 3,
        fontWeight: 500,
        margin: null,
        marginTop: 4,
        marginLeft: 0,
        marginBottom: 2,
        marginRight: 0
    },
    h4: {
        fontSize: 2,
        fontWeight: 300,
        margin: null,
        marginTop: 4,
        marginLeft: 0,
        marginBottom: 2,
        marginRight: 0
    },
    h5: {
        fontSize: 1,
        fontWeight: 300,
        margin: null,
        marginTop: 4,
        marginLeft: 0,
        marginBottom: 2,
        marginRight: 0
    },
    h6: {
        fontSize: 1,
        fontWeight: 300,
        margin: null,
        marginTop: 4,
        marginLeft: 0,
        marginBottom: 2,
        marginRight: 0
    },
    li: {
        lineHeight: 1.6,
        marginBottom: 2,
    },
    blockquote: {
        my: 4,
        mx: 0,
        py: 3,
        px: 4,
        bg: 'blockquote.bg',
        borderLeft: t => `5px solid ${t.colors.blockquote.border}`,
        color: 'blockquote.color',
        fontStyle: 'italic',
        '> p': {
            m: 0,
        },
    },
    code: {
        fontFamily: 'monospace',
    },
    inlineCode: {
        backgroundColor: 'inlineCode.bg',
        border: t => `1px solid ${t.colors.border}`,
        borderRadius: '0.25em',
        fontFamily: 'monospace',
        fontSize: '0.95rem',
        p: 1
    },
    pre: {
        my: 4,
        p: 3,
        variant: 'prism',
        textAlign: 'left',
        fontFamily: 'monospace',
        borderRadius: 'radius',
        border: t => `1px solid ${t.colors.border}`
    },
    img: {
        borderRadius: 'radius',
    },
    table: {
        width: '100%',
        my: 4,
        borderCollapse: 'separate',
        borderSpacing: 0,
        [['th', 'td']]: {
            py: '10px',
            px: '10px',
            // pr: '4px',
            // pl: 0,
            borderBottom:  t => `1px solid ${t.colors.border}`,
        },
    },
    th: {
        lineHeight: 1.6,
        fontFamily: '\'Rubik\', sans-serif !important',
        verticalAlign: 'bottom',
        borderBottomWidth: '1px',
        '&:first-of-type': {
            width: '20%'
        },
        '&:last-of-type': {
            paddingRight: 10
        }
    },
    td: {
        lineHeight: 1.6,
        verticalAlign: 'top',
        borderBottomWidth: '0px',
        '&:last-of-type': {
            paddingRight: 10
        }
    },
    hr: {
        border: 0,
        marginY: 20,
        marginX: 0,
        borderBottom: t => `1px solid ${t.colors.border}`,
    },
    p: {
        lineHeight: 1.8,
    }
}

export default styles